import BaseModel from "../base/BaseModel.model";
import { YearPeriod } from '@/enums/YearPeriod';

export default class PorposalBudgetSubItemInstitutionDetail extends BaseModel {
  public porposalSubItemId?: number;
  public amount?: number;

  public yearNumber?: number;
  public periodNumber?: number;
  public yearPeriod?: YearPeriod = YearPeriod.ThreeMonth;

  public institutionName?:string | null;
  public researchCenterId?:number| null = null;

  public isFondocyt?:boolean;

  constructor(){
     super();
     this.init();
  }

  init() {
    this.porposalSubItemId = 0;
    this.amount = 0;
    this.yearNumber = 0;
    this.periodNumber = 0;
    this.yearPeriod = YearPeriod.ThreeMonth;
    this.institutionName = null;
    this.isFondocyt = false;
  }
}
